import { NEW_DESIGN_FEATURE_FLAG } from "@shared/common/constants";
import { useSelectUser } from "@shared/utils/hooks/misc";
import { IS_WHOP } from "common/constants";
import useIsNewLookForced from "features/newLook/useIsNewLookForced.ts";

/**
 * Whether the platform offers the new design toggle: users with the
 * `new_design` feature flag, outside Whop, who aren't kept in the new design.
 * Login, register and onboarding are in the new design regardless.
 */
const useCanToggleNewLook = () => {
  const user = useSelectUser();
  const isNewLookForced = useIsNewLookForced();
  return (
    !IS_WHOP &&
    !isNewLookForced &&
    !!user?.hasFeatureFlag(NEW_DESIGN_FEATURE_FLAG)
  );
};

export default useCanToggleNewLook;
